module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5MDAiIGhlaWdodD0iNjAwIiB2aWV3Qm94PSIwIDAgMTUwIDEwMCI+PHBhdGggZmlsbD0iI0VEMjkzOSIgZD0iTTAgMGgxNTB2MTAwSDB6Ii8+PHBhdGggZmlsbD0iI0ZGRiIgZD0iTTAgMGg0MHY0MEgweiIvPjxwYXRoIGZpbGw9IiMwMDIzOTUiIGQ9Ik0wIDBoMjB2NDBIMHoiLz48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiNGRkYiIGQ9Ik0wIDQwaDYwVjAiLz48cGF0aCBmaWxsPSIjRkZGIiBkPSJNMTA1IDQ2TDkzIDM0aDI0em0tNCA0TDg5IDM4djI0em00IDRMOTMgNjZoMjR6bTQtNGwxMi0xMnYyNHoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/wlf.svg
// module id = /Z7g
// module chunks = 0